import * as React from 'react'


export const ContinentTag = ({ locationName, className }: { locationName: string, className?: string }) => {
    return <p className={`bg-white inline text-xs font-b px-3 py-1 rounded-xl ${className}`}>{locationName}</p>
}